export const ROI_OPPORTUNITY_REPORT_PATH = '/reports/revenue/opportunities'
